import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { formatViews } from "@/lib/catalog";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col cursor-pointer"
      title={`${movie.title} - 剧情介绍`}
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 封面海报`}
          title={`${movie.title} - 电视剧电影封面`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-80" />

        {typeof rank === "number" && (
          <span className="absolute top-2 left-2 w-7 h-7 rounded-md bg-primary-500 text-background-50 text-sm font-bold flex items-center justify-center">
            {rank}
          </span>
        )}

        <span className="absolute top-2 right-2 px-1.5 h-6 rounded-md bg-accent-500/95 text-foreground-950 text-xs font-bold flex items-center gap-0.5">
          <i className="ri-star-fill text-[10px]"></i>
          {movie.rating.toFixed(1)}
        </span>

        <span className="absolute bottom-2 right-2 text-[11px] text-background-100/90 flex items-center gap-1">
          <i className="ri-eye-line"></i>
          {formatViews(movie.views)}
        </span>
      </div>

      <div className="pt-2.5">
        <h3 className="text-sm md:text-[15px] font-medium text-foreground-950 leading-snug line-clamp-1 group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <div className="mt-1.5 flex items-center gap-1.5 flex-wrap">
          <span className="text-[11px] px-1.5 py-0.5 rounded bg-background-100 text-foreground-600">
            {movie.type === "movie" ? "电影" : "电视剧"}
          </span>
          {movie.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="text-[11px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-800"
            >
              {g}
            </span>
          ))}
          <span className="text-[11px] text-foreground-400">{movie.year}</span>
        </div>
      </div>
    </Link>
  );
}